
import React from "react";
import StudentQuery from "@/components/StudentQuery";

const StudentQueryPage: React.FC = () => {
  return <StudentQuery />;
};

export default StudentQueryPage;
